import React, { Dispatch } from "react";
import { ZIndexLevels } from "../risk/geoUtils";
import TripDrawer, { handleDrawerClose } from "./TripDrawer";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import {
    openMultistartSelection,
    openTripLibrary,
    openTripResults,
    useIsLeftBarExpanded
} from "../../features/Drawer/drawerSlice";
import { StyledTripDrawerToggleButton } from "./TripDrawerStyle";
import { RiskViewerKind, RiskViewerState, useRiskViewerState } from "../../features/riskViewer/riskViewerSlice";
import { useIsMobile } from "../../features/pageWidth/pageWidthSlice";
import { AnyAction } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDirections, faRv } from "@fortawesome/sharp-duotone-light-svg-icons";
import { ROUTE_OVERVIEW, TRIP_LIBRARY } from "../UserVisibleStrings";
import { RouteRequestState } from "../../generated/gpb/api/route";

/**
 * Handles the toggling of the trip drawer.
 */
const handleTripToggle = ( isTripExpanded: boolean, riskViewerState: RiskViewerState, dispatch: Dispatch<AnyAction> ) =>
{
    if ( isTripExpanded )
    {
        handleDrawerClose( riskViewerState.kind, dispatch );
    }
    else
    {
        if ( riskViewerState.kind === RiskViewerKind.TRIP_STATE &&
            riskViewerState.selectedRoute !== undefined &&
            riskViewerState.tripState !== undefined )
        {
            if ( riskViewerState.tripState.processingRequestStatusMultistart === undefined ||
                ( riskViewerState.tripState.routeState === RouteRequestState.ROUTE_SELECTED && riskViewerState.tripState.selectedRouteHex !== undefined ) )
            {
                dispatch( openTripResults( { trip: riskViewerState.tripState, routeId: riskViewerState.selectedRoute } ) );
            }
            else
            {
                dispatch( openMultistartSelection( { trip: riskViewerState.tripState, routeId: riskViewerState.selectedRoute } ) );
            }
        }
        else
        {
            dispatch( openTripLibrary() );
        }
    }
};

/**
 * TripDrawerElement Component
 * Renders the TripDrawer and toggle button based on the drawer state and device type.
 * @returns {JSX.Element} - The trip drawer element.
 */
const TripDrawerElement = (): JSX.Element =>
{
    const isMobile = useIsMobile();
    const isTripExpanded = useIsLeftBarExpanded();
    const riskViewerState = useRiskViewerState();
    const dispatch = useDispatch();

    return (
        <React.Fragment>
            <TripDrawer/>
            {!( isMobile && isTripExpanded ) && (
                <StyledTripDrawerToggleButton
                    isTripExpanded = {isTripExpanded}
                    onClick = {() => handleTripToggle( isTripExpanded, riskViewerState, dispatch )}
                    isMobile = {isMobile}
                    riskViewerStateKind = {riskViewerState.kind}
                    id = "step7"
                >
                    {isTripExpanded ? (
                        <KeyboardArrowLeftIcon sx = {{ left: "-5px", position: "relative", zIndex: ZIndexLevels.TopUIElement }}/>
                    ) : (
                        <div style = {{ display: "flex", flexDirection: "column", alignItems: "center", zIndex: ZIndexLevels.TopUIElement }}>
                            <KeyboardArrowRightIcon/>
                            <h4 style = {{ margin: 0, writingMode: "vertical-rl" }}>{riskViewerState.kind === RiskViewerKind.TRIP_STATE ? ROUTE_OVERVIEW : TRIP_LIBRARY}</h4>
                            <FontAwesomeIcon icon = {riskViewerState.kind === RiskViewerKind.TRIP_STATE ? faDirections : faRv} size = "lg" fixedWidth style = {{ transform: "rotate(90deg)", paddingLeft: "15px" }}/>
                        </div>
                    )}
                </StyledTripDrawerToggleButton>
            )}
        </React.Fragment>
    );
};

export default TripDrawerElement;
